<template>
	<div>
    <el-dialog
      :title="$t('card').pop_txt1"
      :visible.sync="show"
      :close-on-click-modal="false"
      width="30%"
      :before-close="handleClose"
    >
      <div class="machine-dialog">
        <div class="machine-list">
          <div v-for="(item, index) in listData" :key="item.vemId" class="machine-item" @click="handleSelect(index)">
            <div class="check-box" :class="{ 'cur': index == listIndex }"></div>
            <img class="machine-pic" :src="item.vemimg" />
            <div class="machine-cont">
              <div class="machine-hd">
                <div class="machine-name">{{ item.vemName }}</div>
                <div class="machine-location">
                  <svg-icon iconClass="location" />
                  <span>{{ item.distance }}{{ item.distanceunit }}</span>
                </div>
              </div>
              <div class="machine-address">{{ item.vemaddress }}</div>
            </div>
          </div>
        </div>
        <div class="dialog-footer">
          <el-button
            type="primary"
            :loading="loading"
            :disabled="listIndex === -1"
            @click="handleConfirm"
          >
            {{ $t('public_head').confirm_text }}
          </el-button>
        </div>
      </div>
    </el-dialog>
    <el-dialog
      :visible.sync="codePop"
      width="320px"
      :close-on-click-modal="false"
      :show-close="true"
      :before-close="handleCodeClose"
    >
      <div class="code-dialog">
        <div class="item-desc">{{ codeInfo.sharetext }}</div>
        <div class="item-num">{{ codeInfo.pickupCode }}</div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
	import { confirmorderveminfo } from '@/api/orderuser'
	export default {
		data() {
			return {
				show: false,
				listIndex: -1,
				listData: [],
				loading: false,
				codePop: false,
				codeInfo: {}
			}
		},
		computed: {
			lang() {
				return this.$t('order_confirm')
			}
		},
		methods: {
			async init(listData, listIndex = 0) {
				this.listIndex = listIndex
				this.show = true
				this.listData = listData
			},
			handleSelect(index) {
				this.listIndex = index
			},
			async getCode(itemid, vemId) {
                try {
                    this.loading = true
                    const res = await confirmorderveminfo({
                        itemid,
                        vemId
                    })
                    if (res.code === 1) {
                        this.show = false
                        this.codePop = true
                        this.codeInfo = res.data
                        setTimeout(() => {
                            this.$emit('update')
                        }, 1000)
                    } else {
						this.$message.error(res.msg)
                    }
                    this.loading = false
                } catch {
                    this.loading = false
                }
			},
			async handleConfirm() {
				this.show = false
				this.$emit('confirm', this.listIndex)
			},
			handleClose() {
				this.show = false
			},
			handleCodeClose() {
				this.codePop = false
			}
		}
	}
</script>

<style lang="scss" scoped>
.machine-dialog {
	.machine-list {
		max-height: 60vh;
		overflow-y: auto;
	}
	.machine-item {
		display: flex;
		align-items: center;
		padding: 15px 0;
		border-bottom: 1px solid #f1f1f1;
		cursor: pointer;
		&:last-child {
			border-bottom: none;
		}
	}
	.check-box {
		width: 12px;
		height: 12px;
		border: 1px solid #ec9221;
		border-radius: 50%;
		margin-right: 15px;
		&.cur {
			background: #ec9221;
		}
	}
	.machine-pic {
		width: 68px;
		height: 40px;
		border-radius: 8px;
		margin-right: 15px;
	}
	.machine-cont {
		flex: 1;
	}
	.machine-hd {
		display: flex;
		justify-content: space-between;
		align-items: center;
		margin-bottom: 5px;
	}
	.machine-name {
		font-size: 14px;
		color: #000;
	}
	.machine-location {
		display: flex;
		align-items: center;
		svg {
			width: 13px;
			margin-right: 4px;
		}
		span {
			font-size: 12px;
			color: #4F4F4F;
		}
	}
	.machine-address {
		font-size: 12px;
		color: #666;
	}
	.dialog-footer {
		text-align: center;
		margin-top: 20px;
		/deep/ .el-button {
			background-color: #EC9221;
			border-color: #EC9221;
			&:disabled {
				background-color: #ddd;
				border-color: #ddd;
			}
		}
	}
}

.code-dialog {
	text-align: center;
	padding: 20px;
	.item-desc {
		font-size: 16px;
		color: #666;
		margin-bottom: 15px;
	}
	.item-num {
		font-weight: bold;
		color: #ff0000;
		font-size: 24px;
		letter-spacing: 6px;
	}
	.item-copy {
		color: #EC9221;
		cursor: pointer;
		font-size: 14px;
	}
}
</style>
